export default __webpack_public_path__ + "static/media/default-homepage-hero-mobile.4fe5fd48.jpg";